export default {
  INIT_FINANCES: (state, payload) => {
    state.finances = payload;
  },
  INIT_FINANCE_INFO: (state, payload) => {
    state.financeInfo = payload;
  },
  INIT_COMPANIES: (state, payload) => {
    state.companies = payload;
  },
  INIT_COMMERCIALISTS: (state, payload) => {
    state.commercialists = payload;
  },
  INIT_PAGER: (state, payload) => {
    state.pager = payload;
  },
  INIT_TOWNS: (state, payload) => {
    state.towns = payload;
  },
  INIT_TOWN: (state, payload) => {
    state.town = payload;
  },
  SELECT_COMPANY: (state, payload) => {
    state.company = payload;
  },
  INIT_USERS: (state, payload) => {
    state.users = payload;
  },
  SELECT_USER: (state, payload) => {
    state.selectedUser = payload;
  },
  SELECT_USER_SHIPPING_INFO: (state, payload) => {
    state.userShippingInfo = payload;
  },
  INIT_TOKEN: (state, payload) => {
    state.token = payload;
  },
  INIT_PROFILE_DATA: (state, payload) => {
    localStorage.setItem('profile-main', JSON.stringify(payload));
    state.profile = payload;
  },
  INIT_SHIPPING_ADDRESSES: (state, payload) => {
    state.shippingAddresses = payload;
  },
  INIT_SHIPPING_ADDRESS: (state, payload) => {
    state.shippingAddress = payload;
  },
  SAVE_COMPANY: (state, payload) => {
    state.selectedCompany = payload;
  },
  INIT_COUNTRIES: (state, payload) => {
    state.countries = payload;
  },
  INIT_COUNTRY: (state, payload) => {
    state.country = payload;
  },
  INIT_SHIPPING_TOWNS: (state, payload) => {
    state.shippingTowns = payload;
  },
  INIT_USER_PROFILE: (state, payload) => {
    state.userProfile = payload;
  },
  INIT_CATEGORIES: (state, payload) => {
    state.categories = payload;
  },
  INIT_SIMPLIFIED_CATEGORIES: (state, payload) => {
    state.simplifiedCategories = payload;
  },
  INIT_CATEGORY: (state, payload) => {
    state.category = payload;
  },

  // Articles
  INIT_ARTICLES: (state, payload) => {
    state.articles = payload;
  },
  INIT_ARTICLE: (state, payload) => {
    state.article = payload;
  },
  GET_CUSTOMER_ARTICLES: (state, payload) => {
    state.userArticles = payload;
  },
  GET_CUSTOMER_ARTICLES_FILTER: (state, payload) => {
    state.userArticlesFilter = payload;
  },
  GET_NEWLY_ADDED_ARTICLES: (state, payload) => {
    state.newlyAddedArticles = payload;
  },
  GET_NEWLY_ADDED_ARTICLES_FILTER: (state, payload) => {
    state.newlyAddedArticlesFilter = payload;
  },
  INIT_SEARCH_ARTICLES: (state, payload) => {
    state.searchArticles = payload;
  },
  INIT_SEARCH_VIEW_ARTICLES: (state, payload) => {
    state.searchViewArticles = payload;
  },
  INIT_SEARCH_FILTERS: (state, payload) => {
    state.searchFilters = payload;
  },
  INIT_QUICK_ARTICLE: (state, payload) => {
    state.quickArticle = null;
    state.quickArticle = payload;
  },
  INIT_RECENT_ARTICLES: (state, payload) => {
    state.recentArticles = payload;
  },
  INIT_MY_ARTICLES: (state, payload) => {
    state.myArticles = payload;
  },
  INIT_MY_ARTICLES_FILTER: (state, payload) => {
    state.myArticlesFilter = payload;
  },
  INIT_SALE_ARTICLES: (state, payload) => {
    const productsOnSale = [];
    if (payload) {
      payload.forEach((e) => {
        const itemsOnSale = e.productSaleItems.map((item) => ({
          ...item,
          quantity: 0,
        }));
        productsOnSale.push(...itemsOnSale);
      });
    }
    state.articlesOnSale = productsOnSale;
  },

  INIT_CATEGORIES_FILTER: (state, payload) => {
    state.categoriesFilters = payload;
  },
  INIT_REVIEWS: (state, payload) => {
    state.reviews = payload;
  },
  INIT_BANKS: (state, payload) => {
    state.banks = payload;
  },
  INIT_BANK: (state, payload) => {
    state.bank = payload;
  },

  // Currencies
  INIT_CURRENCIES: (state, payload) => {
    state.currencies = payload;
  },
  INIT_CURRENCY: (state, payload) => {
    state.currency = payload;
  },
  INIT_MEASUREMENT_UNITS: (state, payload) => {
    state.measurementUnits = payload;
  },

  // Brands
  INIT_BRANDS: (state, payload) => {
    state.brands = payload;
  },
  INIT_BRAND: (state, payload) => {
    state.brand = payload;
  },
  INIT_ALL_BRANDS: (state, payload) => {
    state.allBrands = payload;
  },

  // Taxes
  INIT_TAXES: (state, payload) => {
    state.taxes = payload;
  },

  // Express posts
  INIT_EXPRESS_POSTS: (state, payload) => {
    state.expressPosts = payload;
  },
  INIT_EXPRESS_POST: (state, payload) => {
    state.expressPost = payload;
  },

  // Tabs
  INIT_TABS: (state, payload) => {
    state.tabs = payload;
  },
  INIT_TAB: (state, payload) => {
    state.tab = payload;
  },

  // Product sales
  INIT_PRODUCT_SALES: (state, payload) => {
    state.productSales = payload;
  },
  INIT_PRODUCT_SALE: (state, payload) => {
    state.productSale = payload;
  },

  // Interests areas
  INIT_INTERESTS_AREAS: (state, payload) => {
    state.interestsAreas = payload;
  },
  INIT_INTERESTS_AREA: (state, payload) => {
    state.interestsArea = payload;
  },

  // Customer bank account
  INIT_CUSTOMER_BANK_ACCOUNTS: (state, payload) => {
    state.customerBankAccounts = payload;
  },
  INIT_CUSTOMER_BANK_ACCOUNT: (state, payload) => {
    state.customerBankAccount = payload;
  },

  // Blogs
  INIT_BLOGS: (state, payload) => {
    state.blogs = payload;
  },
  INIT_RECENT_BLOGS: (state, payload) => {
    state.recentBlogs = payload;
  },
  INIT_BLOG: (state, payload) => {
    state.blog = payload;
  },

  // Terms of services
  INIT_TERMS_OF_SERVICES: (state, payload) => {
    state.terms = payload;
  },

  // Attributes
  INIT_ATTRIBUTES: (state, payload) => {
    state.attributes = payload;
  },
  INIT_ATTRIBUTE: (state, payload) => {
    state.attribute = payload;
  },
  INIT_ATTRIBUTE_VALUES: (state, payload) => {
    state.attributeValues = payload;
  },
  INIT_ARTICLE_VARIATIONS: (state, payload) => {
    state.articleVariations = payload;
  },

  // HomePage
  INIT_JUMBOTRONS: (state, payload) => {
    state.jumbotrons = payload;
  },
  INIT_HIGHLIGHTED_CATEGORIES: (state, payload) => {
    state.highlightedCategories = payload;
  },
  INIT_HIGHLIGHTED_BRAND: (state, payload) => {
    state.highlightedBrand = payload;
  },
  INIT_TOP_BRANDS: (state, payload) => {
    state.topBrands = payload;
  },
  INIT_WISHLIST: (state, payload) => {
    state.wishlist = payload;
  },

  // Shopping Carts
  INIT_SHOPPING_CART: (state, payload) => {
    state.shoppingCart = payload;
  },
  INIT_SHOPPING_CARTS: (state, payload) => {
    state.shoppingCarts = payload;
  },

  // Orders
  INIT_ORDERS: (state, payload) => {
    state.orders = payload;
  },
  INIT_ORDER: (state, payload) => {
    state.order = payload;
  },

  // Messages
  INIT_MESSAGES: (state, payload) => {
    state.messages = payload;
  },
  INIT_UNREAD_MESSAGES_COUNT: (state, payload) => {
    state.unreadMessagesCount = payload;
  },

  // User files
  INIT_USER_FILES: (state, payload) => {
    state.userFiles = payload;
  },

  // Tags
  INIT_MOST_POPULAR_TAGS: (state, payload) => {
    state.mostPopularTags = payload;
  },

  // Complaints
  INIT_COMPLAINTS: (state, payload) => {
    state.complaints = payload;
  },

  // Parameters
  INIT_FREE_SHIPPING_AMOUNT: (state, payload) => {
    state.freeShippingAmount = payload;
  },
  INIT_ALLOW_ORDERING_STOCK_ZERO: (state, payload) => {
    state.allowOrderingStockZero = !!payload;
  },
  INIT_FREE_SHIPPING_ENABLED: (state, payload) => {
    state.freeShippingEnabled = payload;
  },
  INIT_USE_DEFAULT_LANGUAGE: (state, payload) => {
    state.useDefaultLanguage = payload;
  },
  INIT_DEFAULT_LANGUAGE: (state, payload) => {
    state.defaultLanguage = payload;
  },
  INIT_LANGUAGES: (state, payload) => {
    state.languages = payload;
  },

  // Modals
  INIT_OUT_OF_STOCK_MODAL: (state, payload) => {
    state.outOfStockModal = payload;
  },
};
